import { useRightToLeftStylesheets } from '@/utils/language/rightToLeftStylesheets'

const RIGHT_TO_LEFT_LOCALES = ['ar']

let languageBeforeRightToLeft = null

export const isRightToLeftLocale = (locale) => RIGHT_TO_LEFT_LOCALES.includes(locale)

/**
 * Sets `dir` (and, for right-to-left locales, `lang`) on <html> for the presenter UI
 * locale. Every other locale gets `dir="ltr"` and its original `lang` back.
 */
export const applyDocumentDirection = (locale, root = document.documentElement) => {
  if (!root) return
  if (isRightToLeftLocale(locale)) {
    if (root.getAttribute('dir') !== 'rtl') languageBeforeRightToLeft = root.getAttribute('lang')
    root.setAttribute('dir', 'rtl')
    root.setAttribute('lang', locale)
    useRightToLeftStylesheets()
    return
  }
  if (root.getAttribute('dir') === 'rtl' && languageBeforeRightToLeft) {
    root.setAttribute('lang', languageBeforeRightToLeft)
  }
  root.setAttribute('dir', 'ltr')
}
